<template>
  <div>
    <div class="header">
      <div class="user">
        <div class="userIcon"></div>
        <span>{{ userInfo.name }}</span>
        <es-tooltip class="item" effect="dark" :content="$t(`退出`)" placement="top-end">
          <div class="out" @click="goOut"></div>
        </es-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  methods: {
    goOut() {
      this.$ajax(this.$url.logout(), {}).then(() => {
        this.$ajax(this.$url.getInfo(), {})
      })
    },
  },
}
</script>
<style lang="less" scoped>
.user {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  align-items: center;
  justify-content: flex-end;
  > span {
    margin: 0 20px;
    font-size: 14px;
    color: #ffffff;
    font-weight: 500;
  }
}
.header {
  height: 158px;
  width: 100%;
  background: url('../assets/common/inviteHeader.png') no-repeat;
  background-size: 100% 100%;
}
.userIcon {
  width: 24px;
  height: 24px;
  background: url('../assets/icons/me.png') no-repeat;
  background-size: 100% 100%;
}
.out {
  width: 16px;
  height: 14px;
  background: url('../assets/icons/out.png') no-repeat;
  background-size: 100% 100%;
}
</style>
